const customerReducer = (state = null, action) => {
  switch (action.type) {
    case 'CUSTOMER_POPUP_SET': return action.payload;
    case 'CUSTOMER_POPUP_CLOSE': return null;
    default: return state;
  }
};

export default customerReducer;
